/*
 * @Author: 番茄炒蛋蛋 wzh15802755802@163.com
 * @Date: 2025-03-06 17:54:17
 * @LastEditors: 番茄炒蛋蛋 wzh15802755802@163.com
 * @LastEditTime: 2025-03-31 14:17:55
 * @FilePath: \qbot-api-demo\src\router\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
    mode: 'hash',
    base: '/',
    routes: [
        {
            path: '/',
            name: 'ChatDemo',
            component: r => require.ensure([], () => r(require('@/pages/chat-demo/main.vue')), 'ChatDemo')
        },
        {
            path: '/other',
            name: 'ChatDemo',
            component: r => require.ensure([], () => r(require('@/pages/other/other.vue')), 'other')
        },
    ]
});



// WEBPACK FOOTER //
// ./src/router/index.js